import React, {
  ReactElement,
  useEffect,
  useState,
  useCallback,
} from 'react';
import {
  Button as MUIButton,
  IconButton,
  Stack,
  Table,
  TableContainer,
} from '@mui/material';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { MoreOptions } from '../Table/assets/MoreOptions';
import { toaster } from '../../services/toaster';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { contact } from '../../schema/contact';
import { SlidingPaneEdit } from '../Page/SlidingPaneEdit';
import Tooltip from '@mui/material/Tooltip';
import AddIcon from '@mui/icons-material/Add';
import { serviceProviderContact } from '../../schema/serviceProviderContact';
import api from '../../services/api';
import TableBody from '@mui/material/TableBody';
import { AddNewContact } from '../SalesPartner/AddNewContactForm';
import {salesPartnerContact} from "../../schema/salesPartnerContact";

export const SalesPartnerContact = ({
  schema,
  values,
  tableType,
}: {
  schema: any;
  values: any;
  tableType: string;
}): ReactElement => {
  const [openConfirmDialog, setOpenConfirmDialog] = useState<any>(false);
  const [properties, setProperties] = useState<any>(undefined);
  const [openedSlidingPane, setOpenedSlidingPane] = useState<any>({});
  const [addingEntity, setAddingEntity] = useState<any>({
    schema: undefined,
  });
  const [currentAddNewPaneEntity, setCurrentAddNewPaneEntity] = useState<any>({
    schema: schema,
    row: {},
    key: undefined,
  });

  const fetchContacts = useCallback(() => {
    const searchParams = new URLSearchParams({
      /*activity: values?.id,*/
    });

    api
      .get(`/sales-partners-contacts/${values.id}`, searchParams)
      .then((res: any) => {
        setProperties(res);
      });
  }, []);

  useEffect(() => {
    fetchContacts();
  }, [values, schema]);

  return (
    <>
      <TableContainer component={'div'}>
        <Table
          aria-label="simple table"
          size="small"
          sx={{
            '& .MuiTableBody-root .MuiTableRow-root': {
              background: '#fff',
            },
          }}
        >
          <TableHead
            sx={{
              '& .MuiTableCell-root': {
                color: 'inherit',
                border: 'none',
              },
              '& .MuiTableRow-root .MuiTableCell-root.MuiTableCell-head': {
                border: 'none',
                fontSize: '14px',
                p: '10px',
              },
              background: '#256861',
              color: '#fff',
            }}
          >
            <TableRow
              sx={{
                '& .MuiTableCell-root': {
                  overflowWrap: 'anywhere',
                },
              }}
            >
              <TableCell
                sx={{
                  width: '10%',
                }}
              ></TableCell>
              <TableCell
                sx={{
                  width: '25%',
                }}
              >
                Person
              </TableCell>
              <TableCell
                sx={{
                  width: '25%',
                }}
              >
                Phones
              </TableCell>

              <TableCell
                sx={{
                  width: '25%',
                }}
              >
                Email
              </TableCell>

              <TableCell
                sx={{
                  width: '15%',
                }}
              >
                Roles
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {properties &&
              properties.map((contactUser: any) => {
                return (
                  <TableRow>
                    <TableCell
                      sx={{
                        padding: '5px',
                      }}
                    >
                      <MoreOptions
                        clickOnEdit={() => {
                          setOpenedSlidingPane({
                            schema: contact,
                            row: contactUser,
                            tab: 'services',
                          });
                        }}
                        clickOnDelete={() => {
                          setOpenConfirmDialog({
                            row: contactUser,
                            service_provider: contactUser?.service_provider,
                            tab: 'contacts',
                            schema: contact,
                          });
                        }}
                      />
                    </TableCell>
                    <TableCell
                      sx={{
                        '& > a': {
                          textDecoration: 'underline',
                        },
                        cursor: 'pointer',
                        '&:hover': {
                          background: '#f3f3f3',
                        },
                      }}
                      onClick={() => {
                        setOpenedSlidingPane({
                          schema: contact,
                          row: contactUser,
                          tab: 'services',
                        });
                      }}
                    >
                      <Stack>
                        <b>{contactUser?.name}</b>
                      </Stack>
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: '5px',
                      }}
                    >
                      <Stack
                        sx={{
                          '& > a': {
                            textDecoration: 'underline',
                          },
                        }}
                      >
                        {contactUser?.phone && (
                          <a href={`tel:${contactUser?.phone}`}>
                            {contactUser?.phone}
                          </a>
                        )}
                        {contactUser?.alternative_phone && (
                          <a href={`tel:${contactUser?.alternative_phone}`}>
                            {contactUser?.alternative_phone}
                          </a>
                        )}
                      </Stack>
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: '5px',
                      }}
                    >
                      <Stack
                        sx={{
                          '& > a': {
                            textDecoration: 'underline',
                          },
                        }}
                      >
                        {contactUser?.email && (
                          <a href={`mailto:${contactUser.email}`}>
                            {contactUser.email}
                          </a>
                        )}
                        {contactUser?.alternative_email && (
                          <a href={`mailto:${contactUser.alternative_email}`}>
                            {contactUser.alternative_email}
                          </a>
                        )}
                      </Stack>
                    </TableCell>
                    <TableCell
                      sx={{
                        padding: '5px',
                      }}
                    >
                      {contactUser?.roles && (
                        <>
                          <Stack>
                            {contactUser.roles.map((role: any) => {
                              return <span>{role?.name}</span>;
                            })}
                          </Stack>
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <div>
        <Tooltip
          title={`Add new Contact`}
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -14],
                  },
                },
              ],
            },
          }}
        >
          <IconButton
            color={'primary'}
            onClick={() => {
              /* setAddingEntity({
                              schema: serviceProviderContact,
                              key: 'service_provider',
                            });*/

              setCurrentAddNewPaneEntity({
                row: {
                  id: 'new',
                  service_provider: {
                    id: values.id,
                    name: values.name,
                  },
                },
                schema: serviceProviderContact,
                key: 'service_provider',
              });
            }}
          >
            <AddIcon />
          </IconButton>
        </Tooltip>
      </div>

      {currentAddNewPaneEntity?.row?.id && (
        <>
          {/*  <SlidingPaneAddNew
            schema={currentAddNewPaneEntity?.schema}
            mainSchema={schema}
            id={currentAddNewPaneEntity?.row?.id}
            hasSlidingPane={false}
            onSubmit={(result: any) => {
              setCurrentAddNewPaneEntity({
                schema: schema,
                row: {},
                key: undefined,
              });
              fetchContacts();
            }}
            propertiesFromTable={
              currentAddNewPaneEntity?.row ? currentAddNewPaneEntity?.row : {}
            }
            row={
              currentAddNewPaneEntity?.row ? currentAddNewPaneEntity?.row : {}
            }
            onClose={(value) => {
              setCurrentAddNewPaneEntity({
                schema: schema,
                row: {},
                key: undefined,
              });
            }}
          />*/}

          <AddNewContact
            schema={salesPartnerContact}
            onClose={() => setCurrentAddNewPaneEntity(undefined)}
            onSubmit={() => {
              fetchContacts();
              setCurrentAddNewPaneEntity(undefined);
            }}
            salesPartner={values}
          />
        </>
      )}

      <Dialog
        open={openConfirmDialog}
        onClose={() => {
          setOpenConfirmDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Are you sure you want to delete it?'}
        </DialogTitle>
        <DialogActions>
          <MUIButton
            onClick={() => {
              setOpenConfirmDialog(false);
            }}
          >
            Cancel
          </MUIButton>
          <MUIButton
            variant={'contained'}
            color={'error'}
            onClick={() => {
              const deletedRow = openConfirmDialog?.row;
              api
                .delete(
                  `/service-provider-contacts/${values?.id}/${deletedRow?.id}`
                )
                .then((res: any) => {
                  fetchContacts();

                  toaster.show({
                    intent: 'success',
                    message: `Successfully deleted ${
                      openConfirmDialog?.schema.name
                    }: ${deletedRow?.name ? deletedRow?.name : deletedRow?.id}`,
                  });
                  setOpenConfirmDialog(false);
                })
                .catch((e: any) => {
                  console.log(e);

                  toaster.show({
                    icon: 'error',
                    message: `Error: Unable to delete ${schema.name}: ${
                      deletedRow?.name ? deletedRow?.name : deletedRow?.id
                    }`,
                    intent: 'danger',
                  });
                });
            }}
            autoFocus
          >
            Delete
          </MUIButton>
        </DialogActions>
      </Dialog>

      {openedSlidingPane?.row?.id && (
        <SlidingPaneEdit
          schema={openedSlidingPane?.schema}
          id={openedSlidingPane?.row?.id}
          onSubmit={() => {
            fetchContacts();
            setOpenedSlidingPane({});
          }}
          propertiesFromTable={
            openedSlidingPane?.row ? openedSlidingPane?.row : {}
          }
          onClose={(value) => {
            setOpenedSlidingPane({});
          }}
        />
      )}
    </>
  );
};
